import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { InstitutionMember } from '@backrs_ui/grow-ui/src/redux/coachingDashboard';
import { personName } from '@backrs_ui/grow-ui/src/utils/personName';

type MembersView = Readonly<{
  cohortId: number;
  /** Null until the cohort read lands, and for a cohort that is gone. */
  cohortName: string | null;
  view: 'members' | 'add';
  search: string;
  people: readonly InstitutionMember[];
  selectedCount: number;
}>;

export const useAgentContext = ({
  cohortId,
  cohortName,
  view,
  search,
  people,
  selectedCount,
}: MembersView) => {
  useRegisterAgentContext(
    cohortName === null
      ? null
      : {
          kind: 'list',
          description:
            view === 'add'
              ? `People seated on ${cohortName}'s program who are not in the cohort, offered for adding.`
              : `The people currently in the cohort ${cohortName}.`,
          data: {
            cohort_id: cohortId,
            view,
            search,
            selected_count: selectedCount,
            people: people.map((row) => ({
              id: row.id,
              name: personName(row),
            })),
          },
        },
  );
};
